import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Dashboard from './views/Dashboard.vue'
import Devices from './views/Devices.vue'
import Ledger from './views/Ledger.vue'
import Appeals from './views/Appeals.vue'
import Agreement from './views/Agreement.vue'
import Logs from './views/Logs.vue'
import SystemConfig from './views/SystemConfig.vue'
import H5Content from './views/H5Content.vue'
import Users from './views/Users.vue'
import Packages from './views/Packages.vue'
import './style.css'
Vue.use(VueRouter)
const router = new VueRouter({ routes:[
  {path:'/',component:Dashboard},{path:'/users',component:Users},{path:'/packages',component:Packages},{path:'/devices',component:Devices},{path:'/ledger',component:Ledger},{path:'/appeals',component:Appeals},{path:'/agreement',component:Agreement},{path:'/h5-content',component:H5Content},{path:'/system-config',component:SystemConfig},{path:'/logs',component:Logs}
]})
new Vue({router,render:h=>h(App)}).$mount('#app')
